'use strict';

Object.defineProperty(exports, "__esModule", {
   value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class, _class2, _temp;

var _redux = require('redux');

var _reactRedux = require('react-redux');

var _info = require('redux/modules/info');

var _reactBootstrap = require('react-bootstrap');

var _components2 = require('components');

var _reactRouter = require('react-router');

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
   InfoPage: {
      displayName: 'InfoPage'
   }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
   filename: '/home/Devel/web/productionRc/Agama2016/src/components/InfoPage/InfoPage.js',
   components: _components,
   locals: [],
   imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
   return function (Component) {
      return _reactTransformCatchErrors2(Component, id);
   };
}

var InfoPage = _wrapComponent('InfoPage')((_dec = (0, _reactRedux.connect)(function (state) {
   return { data: state.info.data };
}, function (dispatch) {
   return (0, _redux.bindActionCreators)({ setUiProps: _info.setUiProps }, dispatch);
}), _dec(_class = (_temp = _class2 = function (_Component) {
   (0, _inherits3.default)(InfoPage, _Component);

   function InfoPage() {
      (0, _classCallCheck3.default)(this, InfoPage);
      return (0, _possibleConstructorReturn3.default)(this, (InfoPage.__proto__ || (0, _getPrototypeOf2.default)(InfoPage)).apply(this, arguments));
   }

   (0, _createClass3.default)(InfoPage, [{
      key: 'render',
      value: function render() {
         // const {data } = this.props; // eslint-disable-line no-shadow
         // const ui = data.ui;
         var styles = require('./InfoPage.scss');
         var nightPragma = null;
         if (_config2.default.app.night) {
            nightPragma = _react3.default.createElement(
               'div',
               { className: styles.nightPragma },
               _react3.default.createElement(
                  'h2',
                  null,
                  '! Toto je no\u010Dn\xED testovac\xED verze (Nightly Build)'
               ),
               'Tato verze obsahuje posledn\xED novinky i opravy chyb, av\u0161ak nemus\xED b\xFDt pln\u011B stabiln\xED a tedy i v\u017Edy dostupn\xE1. Sestavuje se automaticky v noci (av\u0161ak jen pokud do\u0161lo k n\u011Bjak\xE9 zm\u011Bn\u011B). Slou\u017E\xED k tomu, aby se p\u0159\xEDpadn\xE9 chyby odladily p\u0159ed ofici\xE1ln\xEDm publikov\xE1n\xEDm na ',
               _react3.default.createElement(
                  'a',
                  { href: 'http://agama2000.com' },
                  'agama2000.com'
               ),
               ', kde b\u011B\u017E\xED stabiln\xED ostr\xE1 verze.',
               _react3.default.createElement('br', null),
               _react3.default.createElement(
                  'b',
                  null,
                  'Pozor !!! Tato verze night buildu pou\u017E\xEDv\xE1 sv\u016Fj datov\xFD prostor. To znamen\xE1, \u017Ee ve\u0161ker\xE9 zm\u011Bny, kter\xE9 zde provedete nejsou synchronizov\xE1ny s ostrou verz\xED a mohou b\xFDt kdykoliv odstran\u011Bny. '
               )
            );
         }
         return _react3.default.createElement(
            'div',
            { itemProp: 'mainEntity', itemScope: true, itemType: 'http://schema.org/Organization', className: styles.infoPage },
            nightPragma,
            _react3.default.createElement(
               'div',
               { className: styles.header },
               _react3.default.createElement('img', { src: '/4_free.jpg', className: styles.image }),
               _react3.default.createElement(
                  'h1',
                  null,
                  _react3.default.createElement(
                     'span',
                     { itemProp: 'legalName' },
                     'Agama2000'
                  ),
                  ' - 2017 '
               ),
               _react3.default.createElement(
                  'h2',
                  { itemProp: 'description' },
                  'internetov\xFD zp\u011Bvn\xEDk s akordy '
               ),
               _react3.default.createElement('div', { className: 'clearFix' })
            ),
            _react3.default.createElement(
               'p',
               { itemProp: 'description' },
               '\xA0\xA0V\xE1\u017Een\xED p\u0159\xE1tel\xE9 zp\u011Bvu s kytarou,',
               _react3.default.createElement('br', null),
               'V\xEDtejte na str\xE1nk\xE1ch zp\u011Bvn\xEDku Agama2000. ',
               _react3.default.createElement('br', null),
               'Projekt Agama2000 je nev\xFDd\u011Ble\u010Dn\xFD projekt a jeho c\xEDlem je slou\u017Eit v\u0161em kytarist\u016Fm jako reposit\xE1\u0159 p\xEDsn\xED a d\u011Blat to pokud mo\u017Eno tak, aby se to co nejl\xE9pe pou\u017E\xEDvalo :-). Zp\u011Bvn\xEDk slou\u017E\xED pouze pro v\xFDukov\xE9 \xFA\u010Dely. ',
               _react3.default.createElement('br', null),
               'Tento zp\u011Bvn\xEDk v sou\u010Dasnosti obsahuje p\u0159es 12000 text\u016F, pov\u011Bt\u0161inou s akordy, kter\xE9 jste bu\u010Fto zaslali vy kytarist\xE9, nebo, kter\xE9 byly p\u0159evzaty z datab\xE1ze zp\u011Bvn\xEDk\xE1toru. Je tedy jasn\xE9, \u017Ee ne v\u0161echny texty i akordy jsou spr\xE1vn\u011B, ale na druhou stranu v\u0161ichni m\xE1me mo\u017Enost text i akordy opravit...'
            ),
            _react3.default.createElement(
               'p',
               null,
               _react3.default.createElement(
                  'b',
                  null,
                  'Doporu\u010Den\xFD prohl\xED\u017Ee\u010D je ',
                  _react3.default.createElement(
                     'a',
                     { href: 'http://www.google.com/chrome', target: '_blank' },
                     'Google chrome'
                  )
               ),
               ', ale v\u0161e by se m\u011Blo dob\u0159e zobrazovat  i ve v\u0161ech ostatn\xEDch modern\xEDch prohl\xED\u017Ee\u010D\xEDch (Internet Explorer od verze 11).',
               _react3.default.createElement('br', null),
               'Napi\u0161te Agam\u011B na Facebook, pokud se v\xE1m n\u011Bco nezobrazuje spr\xE1vn\u011B.',
               _react3.default.createElement('br', null)
            ),
            _react3.default.createElement(
               'div',
               { className: styles.socialInfo },
               _react3.default.createElement(
                  'a',
                  { className: styles.fb, itemProp: 'sameAs', href: 'http://facebook.com/agama2000', target: '_blank' },
                  _react3.default.createElement('img', { src: '/social/fb/png/FB-f-Logo__blue_50.png' })
               ),
               _react3.default.createElement('meta', { itemProp: 'url', content: 'http://agama2000.com' }),
               _react3.default.createElement('meta', { itemProp: 'sameAs', content: 'http://agama2000.cz' }),
               _react3.default.createElement('meta', { itemProp: 'sameAs', content: 'http://www.agama2000.cz' }),
               _react3.default.createElement('meta', { itemProp: 'sameAs', content: 'http://www.agama2000.cz' }),
               _react3.default.createElement(
                  'i',
                  null,
                  'Agama2000 d\u011Bkuje za va\u0161i p\u0159\xEDze\u0148 a pokud chcete, tak m\u016F\u017Eete Agamu sledovat i na ',
                  _react3.default.createElement(
                     'a',
                     { href: 'http://facebook.com/agama2000', target: '_blank' },
                     'Facebooku'
                  ),
                  '. ',
                  _react3.default.createElement('br', null),
                  'Pokud se v\xE1m zp\u011Bvn\xEDk l\xEDb\xED, vyjad\u0159ete mu podporu t\xEDm, \u017Ee jej lajknete.\xA0\xA0\xA0\xA0'
               )
            ),
            _react3.default.createElement(
               'h2',
               { className: styles.changesHead },
               'Seznam zm\u011Bn'
            ),
            _react3.default.createElement(
               'div',
               null,
               _react3.default.createElement(
                  _components2.VersionSnippet,
                  { version: '2.0.9', isActive: true, date: '3.5.2017' },
                  _react3.default.createElement(
                     'ul',
                     null,
                     _react3.default.createElement(
                        'li',
                        null,
                        _react3.default.createElement(_reactBootstrap.Glyphicon, { glyph: 'music' }),
                        ' Mo\u017Enost volby notace (Bb-B ',
                        _react3.default.createElement(
                           'i',
                           null,
                           'vs'
                        ),
                        ' B-H)'
                     ),
                     _react3.default.createElement(
                        'li',
                        null,
                        _react3.default.createElement(_reactBootstrap.Glyphicon, { glyph: 'music' }),
                        ' Vylep\u0161eno rendrov\xE1n\xED (lze vkl\xE1dat tabulatury, vkl\xE1d\xE1n\xED vide\xED, opravy chyb )'
                     ),
                     _react3.default.createElement(
                        'li',
                        null,
                        _react3.default.createElement(_reactBootstrap.Glyphicon, { glyph: 'th' }),
                        ' Zobrazen\xED textu do v\xEDce sloupc\u016F (aby nebylo pot\u0159eba scrollovat)'
                     ),
                     _react3.default.createElement(
                        'li',
                        null,
                        _react3.default.createElement(_reactBootstrap.Glyphicon, { glyph: 'cog' }),
                        ' P\u0159id\xE1na podpora prohl\xED\u017Ee\u010De IE11'
                     )
                  ),
                  _react3.default.createElement(
                     'div',
                     null,
                     _react3.default.createElement(
                        'b',
                        null,
                        'Defauln\xED notace pro zobrazen\xED byla zm\u011Bn\u011Bna na st\u0159edoevropskou, tedy B-H'
                     ),
                     ' (zm\u011Bnu lze prov\xE9st v menu nastaven\xED)'
                  )
               ),
               _react3.default.createElement(
                  _components2.VersionSnippet,
                  { version: '2.0.8', date: '7.3.2017' },
                  _react3.default.createElement(
                     'ul',
                     null,
                     _react3.default.createElement(
                        'li',
                        null,
                        _react3.default.createElement(_reactBootstrap.Glyphicon, { glyph: 'eye-open' }),
                        ' Mo\u017Enost zve\u0159ej\u0148ovat sv\xE9 playlisty ',
                        _react3.default.createElement(
                           _reactRouter.Link,
                           { to: '/playlists' },
                           '(Ve\u0159ejn\xE9 playlisty)'
                        )
                     ),
                     _react3.default.createElement(
                        'li',
                        null,
                        _react3.default.createElement(_reactBootstrap.Glyphicon, { glyph: 'cog' }),
                        ' Oprava editace v prohl\xED\u017Ee\u010Di FireFox'
                     )
                  )
               ),
               _react3.default.createElement(
                  _components2.VersionSnippet,
                  { version: '2.0.7', date: '14.1.2017' },
                  _react3.default.createElement(
                     'ul',
                     null,
                     _react3.default.createElement(
                        'li',
                        null,
                        _react3.default.createElement(_reactBootstrap.Glyphicon, { glyph: 'pencil' }),
                        ' Editace & ',
                        _react3.default.createElement(
                           _reactRouter.Link,
                           { to: '/create/Song' },
                           'p\u0159id\xE1v\xE1n\xED p\xEDsn\xED'
                        )
                     ),
                     _react3.default.createElement(
                        'li',
                        null,
                        _react3.default.createElement(_reactBootstrap.Glyphicon, { glyph: 'print' }),
                        ' Oprava chyby p\u0159i tisku'
                     )
                  ),
                  _react3.default.createElement(
                     'div',
                     null,
                     'Do Agamy lze op\u011Bt p\u0159id\xE1vat p\xEDsn\u011B (mus\xEDte b\xFDt p\u0159ihl\xE1\u0161eni).'
                  )
               ),
               _react3.default.createElement(
                  _components2.VersionSnippet,
                  { version: '2.0.6', date: '3.6.2016' },
                  _react3.default.createElement(
                     'ul',
                     null,
                     _react3.default.createElement(
                        'li',
                        null,
                        _react3.default.createElement(_reactBootstrap.Glyphicon, { glyph: 'heart' }),
                        ' P\u0159ihla\u0161ov\xE1n\xED + Playlisty'
                     )
                  ),
                  _react3.default.createElement(
                     'div',
                     null,
                     'Do Agamy se lze op\u011Bt p\u0159ihla\u0161ovat (a to pomoc\xED Facebooku nebo Google+). P\u0159ihla\u0161ov\xE1n\xED bylo nutn\xE9, aby bylo mo\u017En\xE9 ukl\xE1dat ',
                     _react3.default.createElement(
                        'b',
                        null,
                        'playlisty'
                     ),
                     '. Tato verze si vy\u017E\xE1dala v\xEDce \u010Dasu, proto\u017Ee bylo nutn\xE9 dod\u011Blat pom\u011Brn\u011B dost dal\u0161\xEDch technick\xFDch v\u011Bc\xED, Va\u0161e p\u0159\xEDpadn\xE9 playlisty z "p\u0159edv\xE1no\u010Dn\xED verze" by m\u011Bly b\xFDt op\u011Bt k dispozici.'
                  )
               ),
               _react3.default.createElement(
                  _components2.VersionSnippet,
                  { version: '2.0.5', date: '28.2.2016' },
                  _react3.default.createElement(
                     'ul',
                     null,
                     _react3.default.createElement(
                        'li',
                        null,
                        _react3.default.createElement(_reactBootstrap.Glyphicon, { glyph: 'phone' }),
                        ' Lep\u0161\xED ovl\xE1d\xE1n\xED na \xFAzk\xFDch displej\xEDch '
                     ),
                     _react3.default.createElement(
                        'li',
                        null,
                        _react3.default.createElement(_reactBootstrap.Glyphicon, { glyph: 'cog' }),
                        ' P\u0159id\xE1na podpora prohl\xED\u017Ee\u010D\u016F Firefox, Opera'
                     ),
                     _react3.default.createElement(
                        'li',
                        null,
                        _react3.default.createElement(_reactBootstrap.Glyphicon, { glyph: 'cog' }),
                        ' Opravy drobn\xFDch chyb v zobrazen\xED p\xEDsn\xED '
                     )
                  )
               ),
               _react3.default.createElement(
                  _components2.VersionSnippet,
                  { version: '2.0.4', date: '15.2.2016' },
                  _react3.default.createElement(
                     'ul',
                     null,
                     _react3.default.createElement(
                        'li',
                        null,
                        _react3.default.createElement(_reactBootstrap.Glyphicon, { glyph: 'film' }),
                        ' ',
                        _react3.default.createElement(
                           'b',
                           null,
                           'Zobrazen\xED vide\xED'
                        ),
                        ' (pokud jsou k dispozici)'
                     ),
                     _react3.default.createElement(
                        'li',
                        null,
                        _react3.default.createElement(_reactBootstrap.Glyphicon, { glyph: 'equalizer' }),
                        ' ',
                        _react3.default.createElement(
                           'b',
                           null,
                           'Transponov\xE1n\xED: zobrazen\xED tla\u010D\xEDtek pro c\xEDlovou stupnici'
                        )
                     ),
                     _react3.default.createElement(
                        'li',
                        null,
                        _react3.default.createElement(_reactBootstrap.Glyphicon, { glyph: 'cog' }),
                        ' Nascrolov\xE1n\xED na vybranou p\xEDse\u0148 '
                     )
                  )
               ),
               _react3.default.createElement(
                  _components2.VersionSnippet,
                  { version: '2.0.3', date: '31.1.2016' },
                  _react3.default.createElement(
                     'ul',
                     null,
                     _react3.default.createElement(
                        'li',
                        null,
                        _react3.default.createElement(_reactBootstrap.Glyphicon, { glyph: 'search' }),
                        ' ',
                        _react3.default.createElement(
                           'b',
                           null,
                           'Vyhled\xE1v\xE1n\xED'
                        )
                     ),
                     _react3.default.createElement(
                        'li',
                        null,
                        _react3.default.createElement(_reactBootstrap.Glyphicon, { glyph: 'cog' }),
                        ' Oprava drobn\xFDch chyb'
                     )
                  )
               ),
               _react3.default.createElement(
                  _components2.VersionSnippet,
                  { version: '2.0.2', date: '14.1.2016' },
                  _react3.default.createElement(
                     'ul',
                     null,
                     _react3.default.createElement(
                        'li',
                        null,
                        _react3.default.createElement(_reactBootstrap.Glyphicon, { glyph: 'print' }),
                        ' ',
                        _react3.default.createElement(
                           'b',
                           null,
                           'Tisk'
                        )
                     ),
                     _react3.default.createElement(
                        'li',
                        null,
                        _react3.default.createElement(_reactBootstrap.Glyphicon, { glyph: 'cog' }),
                        ' Oprava drobn\xFDch chyb v zobrazen\xED'
                     )
                  )
               ),
               _react3.default.createElement(
                  _components2.VersionSnippet,
                  { version: '2.0.1', date: '10.1.2016' },
                  _react3.default.createElement(
                     'ul',
                     null,
                     _react3.default.createElement(
                        'li',
                        null,
                        _react3.default.createElement(_reactBootstrap.Glyphicon, { glyph: 'equalizer' }),
                        _react3.default.createElement(
                           'b',
                           null,
                           'P\u0159id\xE1no transponov\xE1n\xED'
                        )
                     ),
                     _react3.default.createElement(
                        'li',
                        null,
                        'P\u0159id\xE1no ',
                        _react3.default.createElement(
                           'b',
                           null,
                           'zm\u011Bna velikosti p\xEDsma'
                        ),
                        ' p\xEDsn\u011B'
                     ),
                     _react3.default.createElement(
                        'li',
                        null,
                        'Lep\u0161\xED zobrazen\xED panel\u016F'
                     ),
                     _react3.default.createElement(
                        'li',
                        null,
                        'Ru\u010Dn\xED kr\xE1tkodob\xE1 editace p\xEDsn\u011B'
                     )
                  )
               ),
               _react3.default.createElement(
                  _components2.VersionSnippet,
                  { version: '2.0.0 Alpha first preview', date: '4.1.2016' },
                  _react3.default.createElement(
                     'div',
                     null,
                     'Op\u011Btovn\xE9 spu\u0161t\u011Bn\xED serveru, by\u0165 s omezenou funkcionalitou '
                  )
               ),
               _react3.default.createElement(
                  _components2.VersionSnippet,
                  { version: '1.4.3', date: '23.12.2015' },
                  _react3.default.createElement(
                     'div',
                     { id: 'oldAgama' },
                     _react3.default.createElement(
                        'b',
                        null,
                        'Zastaven\xED star\xE9 Agamy- "H\xE1varie"'
                     )
                  ),
                  _react3.default.createElement(
                     'div',
                     null,
                     'spole\u010Dnost, kter\xE1 Agamu hostovala, ',
                     _react3.default.createElement('br', null),
                     'dne 23.12.2015 zastavila server,',
                     _react3.default.createElement('br', null),
                     ' kv\u016Fli velk\xE9mu s\xED\u0165ov\xE9mu provozu.',
                     _react3.default.createElement('br', null),
                     'Nutno dodat, \u017Ee \u0161lo o free hosting,',
                     _react3.default.createElement('br', null),
                     ' a tak se nelze ni\u010Demu divit.',
                     _react3.default.createElement('br', null),
                     'Bohu\u017Eel z technick\xFDch d\u016Fvod\u016F ne\u0161lo ',
                     _react3.default.createElement('br', null),
                     'spustit server na jin\xE9 platform\u011B ',
                     _react3.default.createElement('br', null),
                     'a proto byly webov\xE9 str\xE1nky pozastaveny.',
                     _react3.default.createElement('br', null),
                     'Data zp\u011Bvn\xEDku v\u010Detn\u011B va\u0161ich ',
                     _react3.default.createElement('br', null),
                     'playlist\u016F z\u016Fstala zachov\xE1na.'
                  )
               )
            )
         );
      }
   }]);
   return InfoPage;
}(_react2.Component), _class2.propTypes = {
   data: _react2.PropTypes.object,
   setUiProps: _react2.PropTypes.func.isRequired,
   children: _react3.default.PropTypes.oneOfType([_react3.default.PropTypes.arrayOf(_react3.default.PropTypes.node), _react3.default.PropTypes.node])
}, _temp)) || _class));

exports.default = InfoPage;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/InfoPage/InfoPage.js
// module id = 1180
// module chunks = 0